// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"22":"a8dc38e3d36ff481","626":"12b5615bcbb0e9e2"}[chunkId] + ".js";
};